export const setSubscriptionMessage = ({
  operation = 'subscribe',
  type = 'topic',
  entityName = '',
  entityId = '',
  params = '',
  args = []
}) => ({
  operation,
  args: [
    ...(entityId !== ''
      ? [
          {
            type,
            entityName,
            entityId: decodeURIComponent(entityId),
            params
          }
        ]
      : []),
    ...args
  ]
});

export const parseSubscriptionMessage = async Blob => {
  const reader = new FileReader();
  reader.onload = async () => {
    const result = await JSON.parse(reader.result);
    return result;
  };
  reader.readAsText(Blob);
};
